import React from 'react';
import PropTypes from 'prop-types';
import ButtonSelectorDropdown from '../../../common/zolaUI/ButtonSelectorDropdown/ButtonSelectorDropdown';

import './ChecklistOverflowMenu.less';

const OverflowMenu = props => {
  const { ariaLabel, menuItems, onMenuItemClick, menuPositionX, menuPositionY } = props;

  return (
    <div className="checklist__overflow">
      <ButtonSelectorDropdown
        label={<i className="zola-ui-icon zola-ui-icon-overflow-dots checklist__overflow--icon" />}
        ariaLabel={ariaLabel}
        dropdownItems={menuItems}
        onDropdownItemClick={onMenuItemClick}
        menuPositionX={menuPositionX}
        menuPositionY={menuPositionY}
      />
    </div>
  );
};

OverflowMenu.propTypes = {
  ariaLabel: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    })
  ).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  menuPositionX: PropTypes.oneOf(['right', 'left']),
  menuPositionY: PropTypes.oneOf(['top', 'bottom']),
};

OverflowMenu.defaultProps = {
  ariaLabel: 'More Options',
  menuPositionX: 'left',
  menuPositionY: 'bottom',
};

export default OverflowMenu;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistOverflowMenu/ChecklistOverflowMenu.jsx